// 进入全屏
export const setFullScreen = (dom) => {
  const fullScreen = dom
  if (fullScreen.requestFullscreen) {
    fullScreen.requestFullscreen()
  } else if (fullScreen.msRequestFullscreen) {
    fullScreen.msRequestFullscreen()
  } else if (fullScreen.mozRequestFullScreen) {
    fullScreen.mozRequestFullScreen()
  } else if (fullScreen.webkitRequestFullScreen) {
    fullScreen.webkitRequestFullScreen()
  } else {
    console.log('当前浏览器不支持全屏')
  }
}

// 退出全屏
export const outFullScreen = () => {
  if (document.fullscreenElement) {
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen()
    }
  }
}

// 监听退出全屏
export const listenOutFullScreem = () => {
  return new Promise((resolve) => {
    // 要执行的方法
    const fn = () => {
      if (!document.fullscreenElement) {
        window.removeEventListener('resize', fn)
        resolve(1)
      }
    }
    window.addEventListener('resize', fn)
  })
}
